import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Layout } from './components/Layout/Layout';
import { RTLWrapper } from './components/Layout/RTLWrapper';
import { HomePage } from './pages/Home';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { Terms } from './pages/Terms';
import { NotFoundPage } from './pages/NotFound';
import  Blog from './pages/Blog/Blog';
import PostPage from './pages/Blog/PostPage';

// 支持的语言列表
const SUPPORTED_LANGUAGES = ['en', 'zh', 'ja', 'ko', 'fr', 'de', 'pt', 'ru', 'ar'];

const App: React.FC = () => {
  const { i18n } = useTranslation();
  const location = useLocation();

  // 获取当前语言
  const getCurrentLanguage = () => {
    const pathLang = window.location.pathname.split('/')[1];
    if (SUPPORTED_LANGUAGES.includes(pathLang)) {
      return pathLang;
    }
    return 'en'; // 默认英语
  };

  // 设置语言
  useEffect(() => {
    const currentLang = getCurrentLanguage();
    i18n.changeLanguage(currentLang);
  }, [i18n]);

  useEffect(() => {
    // 从路径中获取语言代码
    const lang = location.pathname.split('/')[1] || 'en';
    document.documentElement.lang = lang;
    if (lang === 'ar') {
      document.documentElement.dir = 'rtl';
    } else {
      document.documentElement.dir = 'ltr';
    }
  }, [location]);

  return (
    <RTLWrapper>
      <Layout>
        <Routes>
          {/* 根路径直接显示英文版，不进行重定向 */}
          <Route path="/" element={<HomePage />} />

          {/* 博客路由 - 不需要语言前缀 */}
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:postName" element={<PostPage />} />
          <Route path={`/privacy-policy`} element={<PrivacyPolicy />} />
          <Route path={`/terms`} element={<Terms />} />
          <Route path={`/blog`} element={<Blog />} />

          {/* 语言路由 */}
          {SUPPORTED_LANGUAGES.map(lang => (
            <React.Fragment key={lang}>
              {/* 带斜杠的路径渲染页面 */}
              <Route path={`/${lang}/`} element={<HomePage />} />
            </React.Fragment>
          ))}

          {/* 404页面 */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Layout>
    </RTLWrapper>
  );
};

export default App; 